var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Auth, Layout, Dependencies } from '~/core/decorator';
import { CompanyService } from '~/services/management-service/company.service';
import { PageService } from '~/utils/page.service';
import ModifyCompany from '~/components/system-manage/company-manage/modify-company.vue';
var CompanyManage = /** @class */ (function (_super) {
    __extends(CompanyManage, _super);
    function CompanyManage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dialog = {
            modifyCompany: false,
        };
        // form 查询表单参数
        _this.queryModel = {
            companyName: '',
        };
        _this.companyObj = {};
        _this.queryCompanyDataSet = [];
        return _this;
    }
    /**
     * 查询公司
     */
    CompanyManage.prototype.refreshData = function () {
        var _this = this;
        this.companyService.queryAllCompanyPage(this.queryModel, this.pageService).subscribe(function (data) {
            _this.queryCompanyDataSet = data;
        });
    };
    CompanyManage.prototype.mounted = function () {
        this.refreshData();
    };
    __decorate([
        Dependencies(CompanyService)
    ], CompanyManage.prototype, "companyService", void 0);
    __decorate([
        Dependencies(PageService)
    ], CompanyManage.prototype, "pageService", void 0);
    CompanyManage = __decorate([
        Auth(11),
        Layout('workspace'),
        Component({
            components: {
                ModifyCompany: ModifyCompany,
            },
        })
    ], CompanyManage);
    return CompanyManage;
}(Vue));
export default CompanyManage;
